import { render } from "./customer_edit.vue?vue&type=template&id=30390878&scoped=true"
import script from "./customer_edit.vue?vue&type=script&lang=js"
export * from "./customer_edit.vue?vue&type=script&lang=js"

import "./customer_edit.vue?vue&type=style&index=0&id=30390878&scoped=true&lang=css"

import exportComponent from "D:\\learning\\isp_digital\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30390878"]])

export default __exports__